const s = () => process.env.NODE_ENV === "development", e = () => !!window.__STORYBOOK__, P = () => window.__DEPLOYMENT__ === "stag" || window.__ENVIRONMENT__ === "staging", r = () => window.__DEPLOYMENT__ === "prod", T = () => window.__ENVIRONMENT__ === "production", t = () => window.__ENVIRONMENT__ === "prod-eu", i = () => window.__ENVIRONMENT__ === "prod-sandbox", R = () => !!window.__NAMESPACE__ || !!window.location.origin.match(
  "-stargate-client.prod-sandbox.amplitude.com"
) || !!window.location.origin.match("-audiences.prod-sandbox.amplitude.com"), c = (n) => {
  var _, o;
  return ((o = (_ = window.__AMP_FEATURE_FLAGS__) == null ? void 0 : _[n]) == null ? void 0 : o.value) === "on";
}, N = () => A("REACT_APP_ENV"), E = {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ANALYTICS_HOST: process.env.REACT_APP_ANALYTICS_HOST,
  REACT_APP_DASH_HOST: process.env.REACT_APP_DASH_HOST,
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL,
  REACT_APP_ORBIT_HOST: process.env.REACT_APP_ORBIT_HOST,
  REACT_APP_PUBLIC_BASE_PATH: process.env.REACT_APP_PUBLIC_BASE_PATH,
  REACT_APP_SKYLAB_BACKEND_HOST: process.env.REACT_APP_SKYLAB_BACKEND_HOST,
  REACT_APP_THUNDER_HOST: process.env.REACT_APP_THUNDER_HOST,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
  REACT_APP_SESSION_REPLAY_HOST: process.env.REACT_APP_SESSION_REPLAY_HOST
}, A = (n) => {
  var _;
  return ((_ = window.env) == null ? void 0 : _[n]) || E[n] || "";
}, O = (n, _) => {
  window.env && (window.env[n] = _), E[n] = _;
};
export {
  N as getCurrentEnvironment,
  A as getEnv,
  s as isDev,
  R as isEphemeralEnv,
  c as isFlagEnabled,
  r as isProd,
  t as isProdEu,
  i as isProdSandbox,
  T as isProdUs,
  P as isStaging,
  e as isStorybook,
  E as processEnv,
  O as setEnv
};
//# sourceMappingURL=env.js.map
